import { isMaybeReadonlyArray as e, getIndexableStringMonad as r, getFromMapOrThrow as i } from "rxdb/plugins/core";
import { CLEANUP_INDEX as n, getIndexName as o } from "../shared/index.js";
export function getIndexId(e, r) {
  var n = o(r);
  return i(e.indexIdByName, n);
}
export function normalizeIndexedDBIndex(r, i) {
  return e(i) ? i.slice(0) : [i];
}
export function getIndexedDBIndexesFromSchema(e) {
  var r = e.indexes ? e.indexes.slice(0) : [];
  return e.properties._meta && e.properties._meta.properties && e.properties._meta.properties.lwt && r.push(["_meta.lwt"]), r = r.map(r => normalizeIndexedDBIndex(e, r));
}
export var INDEXEDDB_DEFAULT_INDEX_SETITNGS = {
  locale: null,
  unique: !1
};
export function createIndexesOnStore(e, r) {
  r.indexIds.forEach(r => {
    e.createIndex(r, r, INDEXEDDB_DEFAULT_INDEX_SETITNGS);
  });
}
export function toIndexRow(e, r, i, n) {
  for (var o = {
      i: i,
      d: n,
      i0: void 0,
      i1: void 0,
      i2: void 0,
      i3: void 0,
      i4: void 0,
      i5: void 0,
      i6: void 0,
      i7: void 0
    }, d = 0; d < e; ++d) {
    var t = (0, r[d])(n);
    o["i" + d] = t;
  }
  return o;
}
export function getIndexableStringByIndexName(e) {
  var i = {},
    d = e.indexes ? e.indexes.map(e => Array.isArray(e) ? e.slice(0) : [e]) : [];
  d.push(n);
  var t = new Map();
  return d.forEach((n, d) => {
    var a = "i" + d,
      x = o(n);
    if (t.has(x)) throw new Error("duplicate index " + x + " " + JSON.stringify(e, null, 4));
    t.set(x, a), i[a] = r(e, n);
  }), {
    indexIdByName: t,
    monadByIndexId: i
  };
}